import React from 'react';
import { Button, CircularProgress, Box } from '@mui/material';
import { colors, fonts, size } from '../../ColorFont/color';

/**
 * BaseButton Component
 * Standardized button with Figma-compliant styling and brand tokens.
 */
const BaseButton = ({
    children,
    onClick,
    variant = "primary",
    fullWidth = true,
    loading = false,
    disabled = false,
    icon,
    sx = {}
}) => {
    const isPrimary = variant === "primary";

    return (
        <Button
            fullWidth={fullWidth}
            variant={isPrimary ? "contained" : "outlined"}
            disableElevation
            disabled={disabled || loading}
            onClick={onClick}
            sx={{
                height: "3.5rem", // 56px rem
                borderRadius: "2rem", // 32px rem
                textTransform: "none",
                fontSize: size.button, // clamped globally in themes
                lineHeight: 1.5,
                fontWeight: 600,
                fontFamily: fonts.poppins,
                display: "flex",
                gap: "0.5rem", // 8px rem
                mb: isPrimary ? '1.5rem' : 0, // margin rem
                backgroundColor: isPrimary ? colors.primary_dark : colors.google_bg,
                color: isPrimary ? colors.light : colors.text_dark,
                border: isPrimary ? "none" : `0.125rem solid ${colors.primary_light}`, // 2px
                boxShadow: isPrimary ? colors.shadow_button_primary : "0px 1px 2px 0px rgba(0, 0, 0, 0.05)",
                "&:hover": {
                    backgroundColor: isPrimary ? colors.primary : "colors.primary_rgba_8",
                    border: isPrimary ? "none" : `0.125rem solid ${colors.primary}`,
                    boxShadow: isPrimary ? colors.shadow_button_primary : "0px 1px 2px 0px rgba(0, 0, 0, 0.05)",
                },
                ...sx
            }}
        >
            <Box sx={{ display: "flex", alignItems: "center", gap: isPrimary ? "0.625rem" : "0.75rem" }}>
                {loading ? (
                    <CircularProgress size={24} color="inherit" />
                ) : (
                    <>
                        {icon && (
                            typeof icon === 'string' ? (
                                <img src={icon} alt="button-icon" style={{ width: isPrimary ? "1rem" : "1.25rem", height: isPrimary ? "1rem" : "1.25rem" }} />
                            ) : (
                                icon
                            )
                        )}
                        {children}
                    </>
                )}
            </Box>
        </Button>
    );
};

export default BaseButton;
